import React from 'react';
import { ReactComponent as UserIcon } from 'assets/svg/user.svg';
import { useSelector } from 'react-redux';
import configEnv from 'env';

const AppHeader = () => {
  const { fullName, avatar } = useSelector((state) => state.auth);
  return (
    <div className="app-header">
      <div className="app-header__info">
        <div className="app-header__fullname">{fullName}</div>
        <div className="app-header__avatar">
          {avatar ? (
            <img className='app-header__img-avatar' src={`${configEnv.STORAGE_BASE_URL}/user/${avatar}`} alt="avatar-user" />
          ) : (
            <UserIcon className="app-header__default-avatar" />
          )}
        </div>
      </div>
    </div>
  );
};

export default AppHeader;
